import React from 'react';
import Header from '@/components/organisms/Header';
import ContainerComponents from '@/components/container';
import Details from '../../shared/components/Details/index';
import CardPurchase from '../../shared/components/CardPurchase/index';
import Footer from '@/components/organisms/Footer';
import {
  CONTAINER_MODEL,
  DETAILS_MODEL,
  CARD_DETAILS,
  FOOTER_MODEL
} from '../models/model';

const StepNoClient = () => {
  return (
    <div className="rbr-section primary-bg o-hidden">
      <Header backGround="ride-sys-color-background-subtle" />
      <div className="container-main container-main-internal-no-cliente">
        <div className="container">
          <ContainerComponents authoring={CONTAINER_MODEL}>
            <Details {...DETAILS_MODEL} />
            <CardPurchase {...CARD_DETAILS} />
          </ContainerComponents>
        </div>
      </div>
      <Footer {...FOOTER_MODEL} />
    </div>
  )
};

export default StepNoClient;